import React, { useEffect, useMemo, useRef, useState } from "react";
import mehak from "../../../../../assets/Mehak.png";
import image1 from "../../../../../assets/Yogit.png";
import image2 from "../../../../../assets/driver1.webp";
import image3 from "../../../../../assets/driver2.webp";
import { useNavigate } from "react-router-dom";
import { VEHICLE_IMAGES } from "../../../../../Utils/Vehicleimg";
import useCustomerDetails from "../../../../Services/Customer/useCustomerDetails";
import CaptainSearchStyles from "./CaptainSearchStyles";
import CancelOrderModal from "./CancelOrderModal";
import CaptainSearchingLeftPanel from "./CaptainSearchingLeftPanel";

const CITY_COORDINATES = {
  Delhi: {
    lat: 28.6139,
    lng: 77.209,
  },
  Noida: {
    lat: 28.5355,
    lng: 77.391,
  },
  Gaziabad: {
    lat: 28.6692,
    lng: 77.4538,
  },
  Ghaziabad: {
    lat: 28.6692,
    lng: 77.4538,
  },
  Gurugram: {
    lat: 28.4595,
    lng: 77.0266,
  },
};

const CaptainSearchingCard = ({
  formData,
  selectedVehicle = "Two Wheeler",
  baseFare = 0,
  onBack,
  onNext,
  vehicleMeta,
}) => {
  const { addTipToFareApi, addTipToFareLoading } = useCustomerDetails();

  const [selectedExtra, setSelectedExtra] = useState(0);
  const [isAccepted, setIsAccepted] = useState(false);
  const [acceptedDriver, setAcceptedDriver] = useState(null);
  const [searchCount, setSearchCount] = useState(1);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [lastClickedExtra, setLastClickedExtra] = useState(null);
  const mapRef = useRef(null);
  const googleMapRef = useRef(null);
  const pickupMarkerRef = useRef(null);
  const dropMarkerRef = useRef(null);
  const driverMarkersRef = useRef([]);
  const radiusCircleRef = useRef(null);
  const radiusWaveRef = useRef(null);
  const tipAddedRef = useRef(false);

  const parcelId = formData?.parcelId || "";

  const navigate = useNavigate();

  const MAX_SEARCH_COUNT = 25;
  const SEARCH_RADIUS_METERS = 2400;

  const selectedCity =
    formData?.city || sessionStorage.getItem("selectedCity") || "Delhi";

  const selectedCityCenter =
    CITY_COORDINATES[selectedCity] || CITY_COORDINATES.Delhi;
  const { car, truck, auto, bike } = VEHICLE_IMAGES;

  const cancellationReasons = [
    "Changed my mind",
    "Pickup address is wrong",
    "Drop address is wrong",
    "Fare is too high",
    "Taking too much time",
    "Booked by mistake",
    "Other reason",
  ];

  const autoAcceptTargetRef = useRef(
    Math.floor(Math.random() * MAX_SEARCH_COUNT) + 1,
  );

  const extraOptions = [10, 20, 30, 50];

  const vehicleBaseFare = useMemo(() => {
    return Number(baseFare || 0);
  }, [baseFare]);

  const totalPrice = useMemo(() => {
    return Number(vehicleBaseFare || 0) + Number(selectedExtra || 0);
  }, [vehicleBaseFare, selectedExtra]);

  const getVehicleIcon = () => {
    const name = String(selectedVehicle || "").toLowerCase();

    if (name.includes("three") || name.includes("auto")) return auto;

    if (
      name.includes("four") ||
      name.includes("eeco") ||
      name.includes("car")
    ) {
      return car;
    }

    if (name.includes("truck") || name.includes("mini")) return truck;

    return bike;
  };

  const vehicleIcon = getVehicleIcon();

  const fakeDrivers = [
    {
      id: 1,
      name: "Mehak Aggarwal",
      rating: "4.8",
      distance: "1.2 km",
      eta: "4 mins",
      top: "18%",
      left: "48%",
      delay: "0s",
      move: "driver-move-1",
      image: mehak,
    },
    {
      id: 2,
      name: "Amit Singh",
      rating: "4.7",
      distance: "1.8 km",
      eta: "6 mins",
      top: "32%",
      left: "68%",
      delay: "0.3s",
      move: "driver-move-2",
      image: image1,
    },
    {
      id: 3,
      name: "Deepak Sharma",
      rating: "4.9",
      distance: "2.1 km",
      eta: "7 mins",
      top: "46%",
      left: "25%",
      delay: "0.6s",
      move: "driver-move-3",
      image: image2,
    },
    {
      id: 4,
      name: "Mohit Verma",
      rating: "4.6",
      distance: "2.4 km",
      eta: "8 mins",
      top: "60%",
      left: "58%",
      delay: "0.9s",
      move: "driver-move-1",
      image: image3,
    },
    {
      id: 5,
      name: "Ravi Kumar",
      rating: "4.8",
      distance: "2.8 km",
      eta: "9 mins",
      top: "70%",
      left: "36%",
      delay: "1.2s",
      move: "driver-move-2",
      image: image1,
    },
    {
      id: 6,
      name: "Vikas Yadav",
      rating: "4.7",
      distance: "3.0 km",
      eta: "10 mins",
      top: "38%",
      left: "43%",
      delay: "1.5s",
      move: "driver-move-3",
      image: image2,
    },
  ];

  const cleanNumber = (value, fallback) => {
    const number = Number(value);

    return Number.isFinite(number) ? number : fallback;
  };

  const pickupLocation = useMemo(() => {
    return {
      lat: cleanNumber(
        formData?.pickupLatitude ||
          formData?.pickupLat ||
          formData?.pickup_latitude,
        selectedCityCenter.lat,
      ),
      lng: cleanNumber(
        formData?.pickupLongitude ||
          formData?.pickupLng ||
          formData?.pickup_longitude,
        selectedCityCenter.lng,
      ),
    };
  }, [formData, selectedCityCenter]);

  const dropLocation = useMemo(() => {
    const hasDropLat =
      formData?.dropLatitude || formData?.dropLat || formData?.drop_latitude;

    const hasDropLng =
      formData?.dropLongitude || formData?.dropLng || formData?.drop_longitude;

    return {
      lat: cleanNumber(
        hasDropLat,
        hasDropLng ? pickupLocation.lat : pickupLocation.lat + 0.018,
      ),
      lng: cleanNumber(
        hasDropLng,
        hasDropLat ? pickupLocation.lng : pickupLocation.lng + 0.018,
      ),
    };
  }, [formData, pickupLocation]);

  const getDriverPositionInsideRadius = (driverIndex) => {
    const centerLat = Number(pickupLocation.lat);
    const centerLng = Number(pickupLocation.lng);

    const angle = (driverIndex * 58 + 25) * (Math.PI / 180);

    const distanceMeters = 450 + driverIndex * 220;

    const earthRadius = 6378137;

    const latOffset = (distanceMeters * Math.cos(angle)) / earthRadius;

    const lngOffset =
      (distanceMeters * Math.sin(angle)) /
      (earthRadius * Math.cos((centerLat * Math.PI) / 180));

    return {
      lat: centerLat + (latOffset * 180) / Math.PI,
      lng: centerLng + (lngOffset * 180) / Math.PI,
    };
  };

  const createAnimatedVehicleOverlay = ({
    map,
    position,
    vehicleIcon,
    driver,
    index,
    isDimmed,
    isAcceptedDriver,
  }) => {
    const animationClasses = [
      "vehicle-animate-up-down",
      "vehicle-animate-left-right",
      "vehicle-animate-diagonal-one",
      "vehicle-animate-diagonal-two",
    ];

    const selectedAnimation = animationClasses[index % animationClasses.length];

    const overlay = new window.google.maps.OverlayView();

    overlay.onAdd = function () {
      const div = document.createElement("div");

      div.className = `map-vehicle-marker ${selectedAnimation} ${
        isAcceptedDriver ? "vehicle-accepted" : ""
      } ${isDimmed ? "vehicle-dimmed" : ""}`;

      div.innerHTML = `
      <div class="map-vehicle-marker-inner ${
        isAcceptedDriver ? "driver-accepted-pulse" : ""
      }">
        <img src="${vehicleIcon}" alt="${driver.name}" />
      </div>
    `;

      div.title = driver.name;

      overlay.div = div;

      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(div);
    };

    overlay.draw = function () {
      const projection = this.getProjection();

      if (!projection || !overlay.div) return;

      const point = projection.fromLatLngToDivPixel(
        new window.google.maps.LatLng(position.lat, position.lng),
      );

      if (!point) return;

      overlay.div.style.left = `${point.x}px`;
      overlay.div.style.top = `${point.y}px`;
    };

    overlay.onRemove = function () {
      if (overlay.div && overlay.div.parentNode) {
        overlay.div.parentNode.removeChild(overlay.div);
      }

      overlay.div = null;
    };

    overlay.setMap(map);

    return overlay;
  };

  const createRadiusWaveOverlay = ({ map, center, radiusMeters }) => {
    const overlay = new window.google.maps.OverlayView();

    overlay.onAdd = function () {
      const div = document.createElement("div");

      div.className = "radius-wave-overlay";

      div.innerHTML = `
      <div class="radius-wave-ring radius-wave-ring-1"></div>
      <div class="radius-wave-ring radius-wave-ring-2"></div>
      <div class="radius-wave-ring radius-wave-ring-3"></div>
    `;

      overlay.div = div;

      const panes = this.getPanes();
      panes.overlayLayer.appendChild(div);
    };

    overlay.draw = function () {
      const projection = this.getProjection();

      if (!projection || !overlay.div) return;

      const centerPoint = projection.fromLatLngToDivPixel(
        new window.google.maps.LatLng(center.lat, center.lng),
      );

      const edgePoint = projection.fromLatLngToDivPixel(
        window.google.maps.geometry.spherical.computeOffset(
          new window.google.maps.LatLng(center.lat, center.lng),
          radiusMeters,
          90,
        ),
      );

      if (!centerPoint || !edgePoint) return;

      const radiusPx = Math.abs(edgePoint.x - centerPoint.x);
      const size = radiusPx * 2;

      overlay.div.style.left = `${centerPoint.x - radiusPx}px`;
      overlay.div.style.top = `${centerPoint.y - radiusPx}px`;
      overlay.div.style.width = `${size}px`;
      overlay.div.style.height = `${size}px`;
    };

    overlay.onRemove = function () {
      if (overlay.div && overlay.div.parentNode) {
        overlay.div.parentNode.removeChild(overlay.div);
      }
      overlay.div = null;
    };

    overlay.setMap(map);

    return overlay;
  };

  const loadGoogleMap = () => {
    const googleKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    if (!googleKey) {
      console.error("Google Maps API key missing in .env");
      return;
    }

    if (window.google?.maps) {
      initMap();
      return;
    }

    const existingScript = document.getElementById("google-maps-script");

    if (existingScript) {
      existingScript.addEventListener("load", initMap);
      return;
    }

    const script = document.createElement("script");
    script.id = "google-maps-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&libraries=geometry`;
    script.async = true;
    script.defer = true;
    script.onload = initMap;

    document.body.appendChild(script);
  };

  const initMap = () => {
    if (!mapRef.current || !window.google?.maps) return;

    if (!googleMapRef.current) {
      googleMapRef.current = new window.google.maps.Map(mapRef.current, {
        center: pickupLocation,
        zoom: 13,
        disableDefaultUI: true,
        zoomControl: true,
        fullscreenControl: true,
        streetViewControl: false,
        mapTypeControl: false,
      });
    }

    renderMapMarkers();
  };

  const clearMapItems = () => {
    if (pickupMarkerRef.current) {
      pickupMarkerRef.current.setMap(null);
    }

    if (dropMarkerRef.current) {
      dropMarkerRef.current.setMap(null);
    }

    if (radiusCircleRef.current) {
      radiusCircleRef.current.setMap(null);
    }

    if (radiusWaveRef.current) {
      radiusWaveRef.current.setMap(null);
      radiusWaveRef.current = null;
    }
    driverMarkersRef.current.forEach((marker) => marker.setMap(null));
    driverMarkersRef.current = [];
  };

  const renderMapMarkers = () => {
    if (!window.google?.maps || !googleMapRef.current) return;

    const map = googleMapRef.current;

    clearMapItems();

    const centerPosition = {
      lat: Number(pickupLocation.lat),
      lng: Number(pickupLocation.lng),
    };

    map.panTo(centerPosition);
    map.setZoom(13);

    // Radius circle around pickup/current location.
    radiusCircleRef.current = new window.google.maps.Circle({
      map,
      center: centerPosition,
      radius: SEARCH_RADIUS_METERS,
      strokeColor: "#2563eb",
      strokeOpacity: 0.22,
      strokeWeight: 1,
      fillColor: "#2563eb",
      fillOpacity: 0.03,
    });

    radiusWaveRef.current = createRadiusWaveOverlay({
      map,
      center: centerPosition,
      radiusMeters: SEARCH_RADIUS_METERS,
    });

    pickupMarkerRef.current = new window.google.maps.Marker({
      map,
      position: centerPosition,
      title: "Pickup Location",
      label: {
        text: "P",
        color: "#ffffff",
        fontWeight: "700",
      },
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 13,
        fillColor: "#2563eb",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 4,
      },
    });

    dropMarkerRef.current = new window.google.maps.Marker({
      map,
      position: dropLocation,
      title: "Drop Location",
      label: {
        text: "D",
        color: "#ffffff",
        fontWeight: "700",
      },
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 12,
        fillColor: "#16a34a",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 3,
      },
    });

    fakeDrivers.forEach((driver, index) => {
      const position = getDriverPositionInsideRadius(index);

      const accepted = isAccepted && acceptedDriver?.id === driver.id;

      const animatedVehicleOverlay = createAnimatedVehicleOverlay({
        map,
        position,
        vehicleIcon,
        driver,
        index,
        isDimmed: isAccepted && !accepted,
        isAcceptedDriver: accepted,
      });

      driverMarkersRef.current.push(animatedVehicleOverlay);
    });
  };

  useEffect(() => {
    loadGoogleMap();
  }, []);

  useEffect(() => {
    if (window.google?.maps && googleMapRef.current) {
      renderMapMarkers();
    }
  }, [pickupLocation, dropLocation, isAccepted, acceptedDriver, vehicleIcon]);

  const handleCancelConfirm = () => {
    if (!cancelReason) return;

    setShowCancelModal(false);
    setCancelReason("");

    navigate("/two-wheeler");
  };

  useEffect(() => {
    if (isAccepted) return;

    const interval = setInterval(() => {
      setSearchCount((prev) => {
        const nextCount = prev + 1;

        if (
          prev >= autoAcceptTargetRef.current ||
          nextCount > MAX_SEARCH_COUNT
        ) {
          clearInterval(interval);

          const randomDriver =
            fakeDrivers[Math.floor(Math.random() * fakeDrivers.length)];

          setAcceptedDriver(randomDriver);
          setIsAccepted(true);

          setTimeout(() => {
            if (onNext) {
              onNext({
                acceptedDriver: randomDriver,
                selectedExtra,
                totalPrice,
              });
            }
          }, 1200);

          return prev;
        }

        return nextCount;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isAccepted, onNext, selectedExtra, totalPrice]);

  const handleExtraClick = async (amount) => {
    if (isAccepted) return;

    // Prevent second API call
    if (tipAddedRef.current) return;

    const response = await addTipToFareApi({
      parcelId,
      tipAmount: amount,
    });

    if (response?.responseCode === "00") {
      tipAddedRef.current = true;

      setSelectedExtra(Number(amount || 0));
      setLastClickedExtra(amount);
    }
  };

  const searchProgress = Math.min((searchCount / MAX_SEARCH_COUNT) * 100, 100);

  return (
    <>
      <CaptainSearchStyles />

      <section className="w-full px-3 pb-6 pt-8 sm:px-4 md:px-6 md:pt-12 lg:px-0 lg:pt-0">
        <div className="mx-auto mt-10 grid w-full max-w-[1020px] grid-cols-1 overflow-hidden rounded-[26px] border border-white/80 bg-white shadow-[0_22px_70px_rgba(15,23,42,0.16)] sm:mt-4 md:mt-10 lg:mt-[120px] lg:h-[800px] lg:grid-cols-[57%_43%]">
          {/* LEFT */}
          <CaptainSearchingLeftPanel
            onBack={onBack}
            isAccepted={isAccepted}
            addTipToFareLoading={addTipToFareLoading}
            searchCount={searchCount}
            MAX_SEARCH_COUNT={MAX_SEARCH_COUNT}
            searchProgress={searchProgress}
            acceptedDriver={acceptedDriver}
            vehicleIcon={vehicleIcon}
            selectedVehicle={selectedVehicle}
            vehicleMeta={vehicleMeta}
            totalPrice={totalPrice}
            selectedExtra={selectedExtra}
            setSelectedExtra={setSelectedExtra}
            extraOptions={extraOptions}
            lastClickedExtra={lastClickedExtra}
            setLastClickedExtra={setLastClickedExtra}
            handleExtraClick={handleExtraClick}
            tipAddedRef={tipAddedRef}
            formData={formData}
            setShowCancelModal={setShowCancelModal}
          />

          {/* RIGHT REAL MAP */}
          <div className="order-1 flex h-[420px] bg-slate-100 p-4 sm:h-[460px] md:h-[500px] lg:order-2 lg:h-full lg:p-5">
            <div className="relative h-full w-full overflow-hidden rounded-3xl border border-white/70 bg-white shadow-inner">
              <div ref={mapRef} className="h-full w-full" />
            </div>
          </div>
        </div>
      </section>

      <CancelOrderModal
        showCancelModal={showCancelModal}
        cancelReason={cancelReason}
        setCancelReason={setCancelReason}
        setShowCancelModal={setShowCancelModal}
        cancellationReasons={cancellationReasons}
        handleCancelConfirm={handleCancelConfirm}
      />
    </>
  );
};

export default CaptainSearchingCard;
